var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropletp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 10.8665C6.13333 10.8665 7.33333 9.64654 7.33333 8.16654C7.33333 7.3932 6.95333 6.65987 6.19333 6.03987C5.43333 5.41987 4.86 4.49987 4.66667 3.5332C4.47333 4.49987 3.90667 5.42654 3.14 6.03987C2.37333 6.6532 2 7.39987 2 8.16654C2 9.64654 3.2 10.8665 4.66667 10.8665Z",
    stroke: "#E10C3C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37339 4.40034C8.8319 3.66776 9.15693 2.8597 9.33339 2.01367C9.66673 3.68034 10.6667 5.28034 12.0001 6.34701C13.3334 7.41367 14.0001 8.68034 14.0001 10.0137C14.0039 10.9352 13.734 11.8371 13.2246 12.6051C12.7152 13.373 11.9893 13.9724 11.1388 14.3273C10.2884 14.6822 9.35167 14.7766 8.44751 14.5985C7.54334 14.4204 6.71241 13.9779 6.06006 13.327",
    stroke: "#E10C3C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropletp);
export default __webpack_public_path__ + "static/media/dropletp.e54db100cb77d7e098fff1fa9fb6bba8.svg";
export { ForwardRef as ReactComponent };